import React from 'react'
import { Breadcrumbs } from '@/components/ui/breadcrumb'
import { links } from 'utils/featureToggles'

import { getTicketBrokerageAndTranslationsFields } from '../../components/Filter/TicketFields/getTicketBrokerageAndTranslationsFields'
import Tickets from './Tickets/Tickets'
import { ticketsTranslationColumn } from './ticketsTranslationColumn'
import { TicketsViewType } from './TicketsViewType'

const TicketsTranslation = (): JSX.Element => (
  <React.Fragment>
    <Breadcrumbs crumbs={[{ title: 'Translation Tickets', link: links.ticketsTranslation.url }]} />
    <Tickets
      viewType={TicketsViewType.Translation}
      columns={ticketsTranslationColumn}
      filterFields={getTicketBrokerageAndTranslationsFields}
    />
  </React.Fragment>
)

export default TicketsTranslation
